// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__BZTeT","text":"SelectPayment_text__1AeJx","title":"SelectPayment_title__1IQKg","btn":"SelectPayment_btn__1ZGE1"};